var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SingleAlert } from "./single-alert";
import React, { useEffect, useState } from 'react';
export const AlertContainer = (props) => {
    const [alertResponse, setAlertResponse] = useState(null);
    const now = new Date();
    const cacheKey = now.getFullYear().toString() + now.getMonth().toString() + now.getDay().toString() + now.getHours().toString() + now.getMinutes().toString();
    useEffect(() => {
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch("/api/alert?documentId=" + props.documentId + "&cachekey=" + cacheKey);
            const data = yield response.json();
            setAlertResponse(data);
        });
        load();
    }, [props.documentId]);
    if (!alertResponse) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null, alertResponse.alerts.map((alert) => React.createElement(SingleAlert, { alert: alert }))));
};
